// ==============================================================
//sale用スライダー
// ==============================================================
$(function(){

  // メインスライダー
  $('.slider').slick({
    autoplay: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '0%',
    variableWidth: true,
    focusOnSelect: true,
    swipe: false,
    asNavFor: '.thumb',

    prevArrow: '<div class="slider-arrow slick-prev prev-arrow"><img src="../../wp-content/themes/realcube_new/assets/images/common/arrow-prev.png" alt=""></div>',
    nextArrow: '<div class="slider-arrow slick-next next-arrow"><img src="../../wp-content/themes/realcube_new/assets/images/common/arrow-next.png" alt=""></div>',

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          swipe: true
        }
      }
    ]
  });

  // サムネイル
  $('.thumb').slick({
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    focusOnSelect: true,
    asNavFor: '.slider'
  });

});



$(window).on("load resize", function() {
    var w = $(window).width();
    var x = 1080;
    if (w <= x) { //768px以下
$(function() {
    $(".slide-item,#slider_wrap").removeClass('active');
    $(".zoomIco,.bgBlack,.closeBtn").click(function() {
        if ($("#thumbnail-list").hasClass('active')) {
            $("#thumbnail-list,.slider-arrow,#slider_wrap").removeClass('active');

        } else {
            $("#thumbnail-list,.slider-arrow,#slider_wrap").addClass('active');
        }
        return false;
    });
});
    } else { //768px以上
 $(function() {
    $(".slide-item,#slider_wrap,.slider-arrow").removeClass('active');
    $(".zoomIco,.bgBlack,.closeBtn,.slide-item").click(function() {
        if ($("#thumbnail-list").hasClass('active')) {
            $("#thumbnail-list,.slider-arrow,#slider_wrap").removeClass('active');
        } else {
            $("#thumbnail-list,.slider-arrow,#slider_wrap").addClass('active');
        }
        return false;
    });
});
    }
});

$(function() {
  $('.slide-item').mouseover(function(e) {
    $('.zoomIco').addClass("active");
    })
  $('.slide-item').mouseout(function(e) {
    $('.zoomIco').removeClass("active");
    })
});

/*if(!navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)){
    $(window).on("load", function() {
        $(function(){
            var timer = false;
            $(window).resize(function() {
                if (timer !== false) {
                    clearTimeout(timer);
                }
            timer = setTimeout(function() {
                //リロードする
                location.reload();
            }, 200);
            });
        });
    });
}*/




